import type { SVGProps } from "react";

export default function InfoIcon(props: Readonly<SVGProps<SVGSVGElement>>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M9.99951 14.3435L9.99951 9.34351"
        stroke="currentColor"
        strokeWidth="1.25528"
        strokeLinecap="round"
      />
      <path
        d="M9.99967 6.01058C9.53944 6.01058 9.16634 6.38368 9.16634 6.84391C9.16634 7.30415 9.53944 7.67725 9.99967 7.67725C10.4599 7.67725 10.833 7.30415 10.833 6.84391C10.833 6.38368 10.4599 6.01058 9.99967 6.01058Z"
        fill="currentColor"
      />
      <path
        d="M1.6665 10.1768C1.6665 6.24846 1.6665 4.28428 2.8869 3.0639C4.10728 1.84351 6.07146 1.84351 9.99984 1.84351C13.9282 1.84351 15.8924 1.84351 17.1128 3.0639C18.3332 4.28428 18.3332 6.24846 18.3332 10.1768C18.3332 14.1052 18.3332 16.0694 17.1128 17.2898C15.8924 18.5102 13.9282 18.5102 9.99984 18.5102C6.07146 18.5102 4.10728 18.5102 2.8869 17.2898C1.6665 16.0694 1.6665 14.1052 1.6665 10.1768Z"
        stroke="currentColor"
        strokeWidth="1.25528"
      />
    </svg>
  );
}
